import styled from 'styled-components'
import { FlexColumn } from 'components/common/common_styles'

export const OuterContainer = styled(FlexColumn)`
  align-items: center;
  background: white;
  min-height: 100vh;
`

export const MenuConditionalDiv = styled.div`
  display: ${ props => (props.mobileOnly ? 'none' : 'contents') };

  @media (max-width: 1140px) {
    display: ${ props => (props.desktopOnly ? 'none' : 'contents') };
  }
`
